<div class="secure__account--completed">
  <div class="app__close--icon mr-[15px] mt-[10px]">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
      <span class="material-icons relative">clear</span>
    </button>
  </div>
  <div class="mx-auto h-44 w-44">
    <!-- <ng-lottie [options]="securedAnimationOptions"></ng-lottie> -->
  </div>
  <p class="secure__account--completed--message">You’ve completed <span class="text-[#25508E] font-bold">Secure my account</span></p>
  <div class="flex justify-center">
    <div class="app__centered-item mt-[-10px]">
      <button class="app__btn--primary" style="width: 204px" (click)="closeDialog()">Done</button>
    </div>
  </div>
</div>
